import React, { ReactNode } from 'react';
import { useNavigationTransition } from '../../Hooks/useNavigationTransition';
import PageWrapper, { TransitionType } from '../PageWrapper';
import './TransitionWrapper.scss';

interface TransitionWrapperProps {
  children: ReactNode;
  transitionType?: TransitionType;
  className?: string;
  style?: React.CSSProperties;
  transitionDuration?: number;
}

const TransitionWrapper: React.FC<TransitionWrapperProps> = ({
  children,
  transitionType = 'fade',
  className = '',
  style = {},
  transitionDuration = 200
}) => {
  const { getPageWrapperClasses, getPageContentClasses } = useNavigationTransition({
    transitionDuration
  });

  return (
    <div className={getPageWrapperClasses()}>
      <div className={getPageContentClasses()}>
        <PageWrapper
          transitionType={transitionType}
          className={className}
          style={style}
        >
          {children}
        </PageWrapper>
      </div>
    </div>
  );
};

export default TransitionWrapper; 